import React, { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet-async';
import { Route, Routes, useNavigate } from 'react-router-dom';

import { pageTitles } from '@/constants/pageTitles';
import ResetPasswordCompletedPage from '@/features/password/components/ResetPasswordCompletedPage';
import ResetPasswordPage from '@/features/password/components/ResetPasswordPage';

const ResetPassword: React.FC = () => {
  const [completed, setCompleted] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (completed) {
      navigate('/password/reset/completed');
    }
  }, [completed, navigate]);

  return (
    <>
      <Helmet>
        <title>{pageTitles.passwordReset}</title>
      </Helmet>
      <Routes>
        <Route
          path=""
          element={<ResetPasswordPage setCompleted={setCompleted} />}
        />
        <Route
          path="completed"
          element={<ResetPasswordCompletedPage completed={completed} />}
        />
      </Routes>
    </>
  );
};

export default ResetPassword;
